// src/domains/onboarding/pages/PlanSelectionPage.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { establishmentsService } from 'infrastructure/firebase';
import { PLANS, PLAN_PROFESSIONAL } from 'shared/config/plans';

const T = {
  brand: '#6B5876', accent: '#C9929A', border: '#E8E5EC',
  s2: '#FAF7FB', s3: '#F0EDF3', text: '#3D3447', text2: '#6B6070', muted: '#A8A1B0',
  success: '#8FC2A6', successBg: '#E7F4ED',
  sans: "'DM Sans',sans-serif", serif: "'Instrument Serif',serif",
};

export default function PlanSelectionPage() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { estabelecimentoId, isProfessional } = location.state || {};

  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);

  const plans = isProfessional ? [PLAN_PROFESSIONAL] : PLANS;

  const handleSelect = async (plan) => {
    if (plan.id === 'enterprise') {
      // Enterprise = contato comercial
      window.location.href = 'mailto:contato@agendapro.com.br?subject=Plano Enterprise';
      return;
    }
    setSelected(plan.id);
    setLoading(true);
    try {
      if (estabelecimentoId) {
        await establishmentsService.update(estabelecimentoId, { planoId: plan.id });
      }
      navigate('/signup/payment', { state: { plano: plan, estabelecimentoId } });
    } finally {
      setLoading(false);
    }
  };

  const isMobile = window.innerWidth < 768;

  return (
    <div style={{ minHeight: '100vh', background: T.s2, fontFamily: T.sans, padding: '32px 16px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: T.serif, fontSize: 32, color: T.brand, marginBottom: 8 }}>
            Escolha seu plano
          </div>
          <p style={{ color: T.text2, fontSize: 15 }}>
            {isProfessional
              ? 'Plano único para profissionais autônomos.'
              : 'Selecione o plano ideal para o tamanho da sua equipe.'}
          </p>
        </div>

        {/* Cards de planos */}
        <div style={{ display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : `repeat(${plans.length > 3 ? 4 : plans.length}, 1fr)`,
          gap: 16, marginBottom: 32 }}>
          {plans.map((plan) => {
            const isPopular = plan.id === 'intermediario';
            const isSel     = selected === plan.id;
            return (
              <div key={plan.id}
                style={{ background: '#fff', borderRadius: 16, padding: 24,
                  border: `2px solid ${isSel ? T.brand : isPopular ? T.accent : T.border}`,
                  position: 'relative', transition: 'all 0.2s',
                  boxShadow: isSel ? `0 4px 20px rgba(107,88,118,0.15)` : 'none' }}>

                {isPopular && (
                  <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                    background: T.accent, color: '#fff', fontSize: 11, fontWeight: 600,
                    padding: '3px 14px', borderRadius: 20, whiteSpace: 'nowrap' }}>
                    Mais popular
                  </div>
                )}

                <div style={{ fontSize: 13, fontWeight: 600, textTransform: 'uppercase',
                  letterSpacing: 1, color: T.muted, marginBottom: 8 }}>
                  {plan.nome}
                </div>

                {plan.preco !== null ? (
                  <div style={{ marginBottom: 12 }}>
                    <span style={{ fontFamily: T.serif, fontSize: 36, color: T.text }}>
                      R$ {plan.preco}
                    </span>
                    <span style={{ fontSize: 13, color: T.muted }}>/mês</span>
                  </div>
                ) : (
                  <div style={{ fontFamily: T.serif, fontSize: 24, color: T.text, marginBottom: 12 }}>
                    Sob consulta
                  </div>
                )}

                <p style={{ fontSize: 13, color: T.text2, marginBottom: 16, lineHeight: 1.5 }}>
                  {plan.descricao}
                </p>

                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px', display: 'flex',
                  flexDirection: 'column', gap: 8 }}>
                  {plan.destaques.map((d, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 8,
                      fontSize: 13, color: T.text2 }}>
                      <span style={{ color: T.success, fontSize: 15, flexShrink: 0 }}>✓</span>
                      {d}
                    </li>
                  ))}
                </ul>

                <button onClick={() => handleSelect(plan)}
                  disabled={loading && isSel}
                  style={{ width: '100%', padding: '11px 0', borderRadius: 10, fontSize: 14,
                    fontWeight: 500, cursor: 'pointer', fontFamily: T.sans, border: 'none',
                    background: isSel || isPopular ? T.brand : T.s3,
                    color: isSel || isPopular ? '#fff' : T.brand,
                    transition: 'all 0.15s' }}>
                  {plan.id === 'enterprise' ? 'Falar com comercial' :
                    loading && isSel ? 'Aguarde...' : 'Selecionar plano'}
                </button>
              </div>
            );
          })}
        </div>

        {/* Link pular */}
        <div style={{ textAlign: 'center' }}>
          <button onClick={() => navigate('/login')}
            style={{ background: 'none', border: 'none', color: T.muted, fontSize: 13,
              cursor: 'pointer', fontFamily: T.sans }}>
            Escolher depois — entrar no sistema
          </button>
        </div>
      </div>
    </div>
  );
}
